import { Component, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { Observable } from 'rxjs/Observable';
import { MenuStore } from '../../../menus/service/menu.store';
import { ReservationUtils } from 'app/event/utils/reservation-utils';
import { List } from 'immutable';
import { ReservationCompare } from 'app/event/models/reservation-compare';
import { PaymentStore } from '../../service/payment.store';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { EventUtils } from 'app/event/utils/event-utils';
import { PaymentStatus } from 'app/event/models/payment-status.enum';

@Component({
  selector: 'pioneer-reservation-page',
  templateUrl: './reservation-page.component.html'
})
export class ReservationPageComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  canManageReservations: boolean;

  constructor(private eventStore: EventStore,
              private reservationCompareStore: ReservationCompareStore,
              private menuStore: MenuStore,
              private paymentStore: PaymentStore,
              private authenticationStore: AuthenticationStore) {
  }

  ngOnInit() {
    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser()),
        this.onyxEvent.eventProperty.subscriber);
    }

    if (!this.onyxEvent.eventId) {
      this.canManageReservations = true;
    } else {
      this.paymentStore.getVendorFinalPayment(this.onyxEvent.eventProperty.eventPartyId).take(1).subscribe(lastFinalPayment => {
        const hasFinalPayment =  Boolean(lastFinalPayment && lastFinalPayment.eventPaymentId);
        this.canManageReservations = !hasFinalPayment || PaymentStatus.REJECTED_WF_APPROVAL === lastFinalPayment.status;
      });
    }
  }

  getSummarySelected(): Observable<boolean> {
    return this.reservationCompareStore.getShowReservationCompareSummary();
  }

  showDownloadDropdown(): Observable<boolean> {
    return this.getFilteredReservations().map((list) => {
      return list && list.size > 0;
    });
  }

  private getFilteredReservations(): Observable<List<ReservationCompare>> {
    return this.reservationCompareStore.getCurrentFilteredReservations()
      .map(reservationList => ReservationUtils.onlyReservationsFilter(reservationList));
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-page/reservation-page.component.ts